import React from 'react';

interface NoDataRowProps {
  colSpan: number;
  message?: string;
}

const NoDataRow: React.FC<NoDataRowProps> = ({
  colSpan,
  message = 'No data found.',
}) => {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center">
        {message}
      </td>
    </tr>
  );
};

export default NoDataRow;
